module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAllBMVEUAAAClKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKiulKisAz4gPAAAAMXRSTlMAAQIGCgsNDhASFRYXGhsjKCouMEJMT19iZGdsc3V7hoiJkaW8yMrO0eLk5ujr7/n7QgmKJgAAAHRJREFUGBltwYkWgUAAhtF/7Ft22SVbRPK9/8vRNJwc7tV/dSBUQQPY6WN8xTp0ZDV5u5eU8RnKiugps6csa8lCL+ZxVm5AJGmUUBD3dVt7J5xZO4xFRRMcoypi5R1xpq0ApXxJZWCrXA0w0vzSlbNJfP14AngSFdK2q0kJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/driver-transaction/brown.png
// module id = jwOq
// module chunks = 2